const ko = require("knockout");
const _isNumber = require("lodash/isNumber");

ko.bindingHandlers.wsMaterialGroup = {
    update: function (element, valueAccessor) {
        // First get the latest data that we're bound to
        let value = valueAccessor();

        // Next, whether or not the supplied model property is observable, get its current value
        let valueUnwrapped = ko.unwrap(value);

        // Now manipulate the DOM element
        $(element).toggleClass("ws-material-group--has-value", !!valueUnwrapped && (valueUnwrapped.length > 0 || _isNumber(valueUnwrapped)));
    }
};

ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        let callback = valueAccessor();
        $(element).keypress(function (event) {
            let keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};

ko.bindingHandlers.buttonPress = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        let callback = valueAccessor();
        $(element)
            .click(function () {
                callback.call(viewModel);
            })
            .keypress(function (event) {
                let keyCode = (event.which ? event.which : event.keyCode);
                if (keyCode === 13 || keyCode === 32) {
                    callback.call(viewModel);
                    return false;
                }
                return true;
            });
    }
};